import { FotoPerfil } from './styles'

const Avatar = () => <FotoPerfil src="https://github.com/eliassgo.png" />

export default Avatar
